import { mediaAPI } from "@/services/api";
import { toast } from "sonner";

export const handleSubmit = async (payload, api, editId = null, adKind, cost, newImages = [], newVideos = [],
																	 is_featured, featured_paid, setLoading, t, navigate) => {

	try {
		// If there's a cost and this is a NEW ad, create as pending then redirect to payment
		if (cost.total > 0 && !editId) {
			const res = await api.create(payload, { pending_payment: true });
			const adId = res.data.id;

			// Upload media immediately (attached to the pending ad)
			for (const img of newImages) {
				const fd = new FormData();
				fd.append('file', img.file);
				fd.append('ad_id', adId);
				fd.append('ad_type', adKind);
				fd.append('ad_status', 'pending');
				await mediaAPI.upload(fd);
			}
			for (const vid of newVideos) {
				const fd = new FormData();
				fd.append('file', vid.file);
				fd.append('ad_id', adId);
				fd.append('ad_type', adKind);
				fd.append('ad_status', 'pending');
				await mediaAPI.uploadVideo(fd);
			}

			// Build line items for checkout
			const lineItems = [];
			if (cost.extraImages > 0) {
				lineItems.push({
					type: 'extra_images',
					label: t('horse.extra_images_cost', { count: cost.extraImages }),
					quantity: cost.extraImages
				});
			}
			if (cost.extraVideos > 0) {
				lineItems.push({
					type: 'extra_videos',
					label: t('horse.extra_videos_cost', { count: cost.extraVideos }),
					quantity: cost.extraVideos
				});
			}
			if (is_featured) {
				lineItems.push({
					type: 'featured_ad', label: t('horse.featured_cost'),
					quantity: 1
				});
			}

			navigate('/payment/checkout', {
				state: { lineItems, total: cost.total, vat: cost.vatPercentage, adType: adKind, adId }
			});
			return;
		}

		// If there's a cost and this is a existent ad, update as pending then redirect to payment
		if (cost.total > 0 && editId) {
			await api.update(editId, payload, { pending_payment: true });

			// Upload media immediately (attached to the pending ad)
			for (const img of newImages) {
				const fd = new FormData();
				fd.append('file', img.file);
				fd.append('ad_id', editId);
				fd.append('ad_type', adKind);
				fd.append('ad_status', 'pending');
				await mediaAPI.upload(fd);
			}
			for (const vid of newVideos) {
				const fd = new FormData();
				fd.append('file', vid.file);
				fd.append('ad_id', editId);
				fd.append('ad_type', adKind);
				fd.append('ad_status', 'pending');
				await mediaAPI.uploadVideo(fd);
			}

			// Build line items for checkout
			const lineItems = [];
			if (cost.extraImages > 0) {
				lineItems.push({
					type: 'extra_images',
					label: t('horse.extra_images_cost', { count: cost.extraImages }),
					quantity: cost.extraImages
				});
			}
			if (cost.extraVideos > 0) {
				lineItems.push({
					type: 'extra_videos',
					label: t('horse.extra_videos_cost', { count: cost.extraVideos }),
					quantity: cost.extraVideos
				});
			}
			if (is_featured && !featured_paid) {
				lineItems.push({
					type: 'featured_ad',
					label: t('horse.featured_cost'),
					quantity: 1
				});
			}

			navigate('/payment/checkout', {
				state: { lineItems, total: cost.total, vat: cost.vatPercentage, adType: adKind, adId: editId }
			});
			return;
		}

		// Free ad or edit mode: proceed directly
		setLoading(true);
		let adId;
		if (editId) {
			await api.update(editId, payload);
			adId = editId;
			toast.success(t('horse.ad_updated'));
		} else {
			const res = await api.create(payload);
			adId = res.data.id;
			toast.success(t('horse.ad_created'));
		}
		// Upload NEW enabled images
		for (const img of newImages) {
			const fd = new FormData();
			fd.append('file', img.file);
			fd.append('ad_id', adId);
			fd.append('ad_type', adKind);
			fd.append('ad_status', 'active');
			await mediaAPI.upload(fd);
		}
		// Upload NEW enabled videos
		for (const vid of newVideos) {
			const fd = new FormData();
			fd.append('file', vid.file);
			fd.append('ad_id', adId);
			fd.append('ad_type', adKind);
			fd.append('ad_status', 'active');
			await mediaAPI.uploadVideo(fd);
		}
		navigate('/dashboard');
	} catch (err) {
		toast.error(err.response?.data?.detail || t('common.error'));
	} finally {
		setLoading(false);
	}

}